import React from "react";
import PropTypes from "prop-types";

export class Conditional extends React.Component {

    componentDidMount() {

        const {onShow} = this.props;
        const collapsed = this.isCollapsed();

        if (!collapsed && onShow) {
            onShow();
        }
    }

    componentDidUpdate(prevProps) {

        const {onCollapse, onShow} = this.props;
        const collapsed = this.isCollapsed();

        if (collapsed !== prevProps.collapsed) {
            if (collapsed) {
                if (onCollapse) {
                    onCollapse();
                }
            } else {
                if (onShow) {
                    onShow();
                }
            }
        }
    }

    static isFunction(functionToCheck) {

        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
    }

    isCollapsed() {

        const {collapsed} = this.props;

        return Conditional.isFunction(collapsed) ? collapsed() : collapsed;
    }

    render() {

        const {children} = this.props;

        return this.isCollapsed() ? null : children;
    }
}

Conditional.propTypes = {
    collapsed: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.func
    ]),
    onCollapse: PropTypes.func,
    onShow: PropTypes.func

};